<template>
  <div>
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :rules="rules"
      :confirmDis="!auditType"
      :wrapper-closable="true"
      :destroy-on-close="true"
      label-width="120px"
      width="500px"
      @handleConfirm="handleConfirm"
    >
      <BjDivider>{{ $t('CustomerFunction.step3') }}</BjDivider>
      <el-col :span="24">
        <el-form-item :label="$t('billingPage.bpCode')" prop="bpCode">
          <BjInputCode :disabled="!auditType" v-model="form.bpCode" :placeholder="$t('billingPage.bpCode')" />
        </el-form-item>
      </el-col>
      <BjDivider>{{ $t('CustomerFunction.onboardingFiles') }}</BjDivider>
      <BjPage ref="BjPage" style="margin-top: -40px;" :get-action="queryApi" :query-params="queryParams" :serial="serial" :selection="selection" :search-btn-hide="true"
        @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" 
        @header-contextmenu="SortableTable.handleHeaderContextmenu" @afterFetchOriginalData="afterFetchOriginalData"
      >
        <template v-slot:tableOperation="tableOperationProp">
            <el-col>
                <el-button :disabled="tableOperationProp.notSelected" type="primary" class="main-btn" @click="batchDownload()">{{$t('batchDownloadText')}}</el-button>
            </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'profitMargin'">
                    <span>{{ scope.row[col.prop] }} %</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                  <el-button type="text" size="small" @click="downloadImageUrl(props.row.url, props.row.name)">{{ $t('downloadText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </BjDrawerForm>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import JSZip from 'jszip';
import { funConfigApi } from '@/api';

const getDefaultForm = () => {
  return {
    id: null,
    bpCode: null,
  };
};

export default {
  mixins: [pageMiXin],
  data() {
    return {
      auditType:false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        bpCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      selection: true,
      queryApi: funConfigApi.getOnboardingDetail,
      queryParams:{
          id:null,
      },
      labelList: [
          {label: this.$t('fileSearch.page.FileName'),prop: 'name',isCheck: true,disabled: false,},
          {label: this.$t('table.operationText'),prop: 'bjTableAction',isCheck: true,disabled: false,width: 160,},
      ],
    };
  },
  methods: {
    show(info) {
      funConfigApi.getOnboardingDetail({id:info.id}).then(res => {
        this.form = Object.assign(getDefaultForm(), res || {});
      });
      this.$refs.BjDrawerForm.show();
    },
    handleConfirm() {
      const POST_DATA = this.$lodash.clone(this.form);
      this.addBPCodeApi(POST_DATA);
    },
    addBPCodeApi(POST_DATA) {
      funConfigApi.putOnboardingList(POST_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh(POST_DATA.bpCode);
            this.$refs.BjDrawerForm.hide();
          }, 500);
        }
      });
    },
    clearForm(){
      this.form = getDefaultForm()
    },
    reFresh(bpCode) {
      this.$emit('financeReFresh',bpCode);
    },
    // 过滤接口数据
    afterFetchOriginalData(res) {
      this.$nextTick(() => {
        this.$refs.BjPage.tableData = res.allFileList;
      });
    },
    // 批量下载
    async batchDownload() {
      if (this.selectedRows.some(item => this.isCrossDomainDownloadUrl(item.url))) {
          this.selectedRows.forEach(item => this.downloadImageUrl(item.url, item.name));
          return;
      }
      const zip = new JSZip();
      for (const item of this.selectedRows) {
          const response = await fetch(this.normalizeDownloadUrl(item.url));
          const blob = await response.blob();
          zip.file(`${item.name}`, blob);
      }
      zip.generateAsync({ type: 'blob' })
        .then(function(content) {
          const url = window.URL.createObjectURL(content);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'onboardingFiles.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
